module.exports = __webpack_public_path__ + "img/iphone8screenshot5.a7738156.png";